// extracted by mini-css-extract-plugin
export default {"container":"card_container__CVyTX","borders-all":"card_borders-all__mwfy5","borders-top":"card_borders-top__G-wVT"};